import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, Icon } from 'ui';
import { injectIntl } from 'react-intl';
import moment from 'utils/cops-moment';
import { withRouter } from 'utils/withRouter';
import { Tag } from 'antd';
import reactStringReplace from 'react-string-replace';
import { cacheSelectedServiceCenter } from '../../utils/service-center';
import { referenceTypesMapping, replacementValueType } from '../../utils/app-configs';

const Tile = styled.div`
  width: 375px;
  height: 250px;
  box-shadow: 0 0 10px 0 #A9BEC8 !important;
  border: 1px solid #A3A3A3;
  background: #fff;
  border-radius: 5px;
  padding: 5px;
  position: relative;
  margin: 0 10px;
  margin-bottom: 20px;
`;

const Info = styled.div`
  margin: 19px 17px;
  font-size: 19px;
`;

const StyledButton = styled(Button)`
  position: absolute;
  bottom: 15px;
  right: 10px;
  background-color: ${p => p.theme.colors.theme} !important;
  color: white;
  text-transform: uppercase;
`;

const Line = styled.p`
  line-height: 24px;
  ${p => p.marginTop && `margin-top: ${p.marginTop}px;`}
`;

const Type = styled(Line)`
  color: rgba(100, 116, 124, 0.85);
  font-weight: 400;
  font-size: 13px;
  margin-top: 8px;
`;

const TitleLine = styled(Line)`
  font-weight: bold;
`;

const StyledIcon = styled(Icon)`
  color: rgb(154, 167, 186);
`;


const MultipleSelectionCard = ({
  type,
  data,
  activeServiceCenterId,
  setActiveServiceCenter,
  history,
  intl,
}) => {
  const redirect = () => {
    history.push(`/${type}/${data.id}/dashboard`, {
      context: data?.contextId || data?.id,
    });
  };

  const handleRedirect = () => {
    if (data?.serviceCenterId !== activeServiceCenterId) {
      const result = cacheSelectedServiceCenter(data?.serviceCenterId);
      setActiveServiceCenter(result);
    }
    redirect();
  };

  const renderButton = () =>
    <StyledButton
      onClick={handleRedirect}
    >
      {intl.formatMessage({ id: 'direct.SHOW_DETAILS' })}
    </StyledButton>;

  const replaceKeyValues = (line) => {
    if (!data?.replacementKeyValues || !Object.keys(data?.replacementKeyValues).length) {
      return line;
    }
    let newLine = line;
    Object.entries(data?.replacementKeyValues).forEach(([key, value]) => {
      switch (value.type) {
        case replacementValueType.date:
          newLine = reactStringReplace(newLine, `{${key}}`, () => moment(value.value).format('L'));
          break;
        case replacementValueType.icon:
          newLine = reactStringReplace(
            newLine, `{${key}}`, () => <StyledIcon type={value.value} />,
          );
          break;
        case replacementValueType.tag:
          newLine = reactStringReplace(newLine, `{${key}}`, () =>
            <Tag closable={false}>
              {value.value}
            </Tag>);
          break;
        default:
          break;
      }
    });
    return newLine;
  };
  const renderData = () =>
    <>
      {data?.line1 ? <Line>{replaceKeyValues(data?.line1)}</Line> : null}
      <Type>{`${referenceTypesMapping[type]}`}</Type>
      {data?.line2 ? <TitleLine marginTop={-6}>{replaceKeyValues(data?.line2)}</TitleLine> : null}
      {data?.line3 ? <Line marginTop={4}>{replaceKeyValues(data?.line3)}</Line> : null}
      {data?.line4 ? <Line>{replaceKeyValues(data?.line4)}</Line> : null}
      {data?.line5 ? <Line>{replaceKeyValues(data?.line5)}</Line> : null}
      {renderButton()}
    </>;

  return (
    <Tile aic jcc ffcn>
      <Info>
        {renderData()}
      </Info>
    </Tile>
  );
};
MultipleSelectionCard.propTypes = {
  type: PropTypes.string,
  data: PropTypes.object,
  intl: PropTypes.object,
  activeServiceCenterId: PropTypes.string,
  setActiveServiceCenter: PropTypes.func,
  history: PropTypes.object,
};

export default injectIntl(withRouter(MultipleSelectionCard));
